import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const massive = defineConnector({
  identifier: "massive",
  name: "Massive",
  tagLine: "Real-time and historical market data",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://(?:api\\.massive\\.com/.*|api\\.polygon\\.io/.*)",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Massive dashboard](https://massive.com/dashboard/keys) (formerly Polygon.io), copy your API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.massive.com/v3/reference/tickers?limit=1",
  },
});
